import { combineReducers } from '@reduxjs/toolkit';

import translations from './translations';

export default combineReducers({
  translations,
});
